jQuery(function($) {
  $('img[usemap]').rwdImageMaps();
});